import { HeaderColorPicker } from "./classes/colorpicker/HeaderColorPicker.js";
import { HeaderRollOut } from "./classes/HeaderRollOut.js";
import { KraissMenu } from "./classes/KraissMenu.js";
import { MobileMenu } from "./classes/MobileMenu.js";
import { MobileMenuSlide } from "./classes/MobileMenuSlide.js";
import { ScrollVisualizer } from "./classes/ScrollVisualizer.js";
import { CSSVariables } from "./helpers/CSSVariables.js";
import { NbspManager } from "./helpers/NbspManager.js";
import { ToFormButton } from "./helpers/ToFormButton.js";
import { Polylux } from "./libs/VANILLA/Polylux/js/Polylux.js";
import { JumpNavigation } from "./modules/JumpNavigation.js";
import { LogoWallPicker } from "./modules/LogoWallPicker.js";
import { ModuleProductsGrid } from "./modules/ModuleProductsGrid.js";
import { ProjectsGrid } from "./modules/ProjectsGrid.js";
import { TabsAccordeonManager } from "./modules/TabsAccordeonManager.js";
import { MegaMenu } from "./navigation/MegaMenu.js";
import { FooterTracking } from "./tracking/FooterTracking.js";
import { HeaderTracking } from "./tracking/HeaderTracking.js";

window.de = window.de || {};
window.de.ww = window.de.ww || {};

window.de.ww.MainApp = class {

    static _polylux = null;

    static validators = []; // :Array<Validator>

    static tooltips = []; // Array<WWTooltips>

    static swipers = [];

    static main() {

        this._polylux = new Polylux();

        new ToFormButton();

        // HEADER COLOR PICKER ***********************************************************************
        //this.headerColorPicker = new HeaderColorPicker();

        document.querySelectorAll('img[sizes]').forEach(img => {
            img.setAttribute('sizes', img.getAttribute('sizes').replace('auto,', '').trim());
        });

        // CSS VARIABLES HELPER ***********************************************************************
        new CSSVariables();

        // OFFCANVAS **********************************************************************************
        let offcanvasElements = [];
        offcanvasElements = document.querySelectorAll(".offcanvas");

        for (let c1 = 0; c1 < offcanvasElements.length; c1++) {

            import('./classes/Offcanvas.js').then(({ Offcanvas }) => {

                new Offcanvas(offcanvasElements[c1]);

            }).catch((err) => { console.warn(err); });

        }

        // NAVIGATION *********************************************************************************
        let navigationWrapper = null;
        navigationWrapper = document.querySelector("#menu-primary-menu");

        // //console.log(navigationWrapper);

        if (navigationWrapper !== null) {

            new KraissMenu(navigationWrapper);
        }

        // MOBILE NAVIGATION SLIDES *******************************************************************
        let mobileNavigationWrapper = null;
        mobileNavigationWrapper = document.querySelector(".header__inner");

        if (mobileNavigationWrapper !== null) {

            new MobileMenuSlide(mobileNavigationWrapper);

        }

        // JUMP NAVIGATION *******************************************************************
        let jumpNavigationWrapper = null;
        jumpNavigationWrapper = document.querySelector(".module-jumpnavigation");

        if (jumpNavigationWrapper !== null) {

            new JumpNavigation(jumpNavigationWrapper);

        }

        // Project Grid *********************************************************************************
        let projectGridWrapper = null;
        projectGridWrapper = document.querySelector(".module-projects-grid__inner");

        // //console.log(projectGridWrapper);

        if (projectGridWrapper !== null) {

            new ProjectsGrid(projectGridWrapper);
        }

        // Jobs Grid *********************************************************************************
        let jobsGridWrapper = null;
        jobsGridWrapper = document.querySelector(".module-jobs-grid");

        // //console.log(jobsGridWrapper);

        if (jobsGridWrapper !== null) {

            new TabsAccordeonManager(jobsGridWrapper);
        }

        // LOGO WALL *******************************************************************
        let logoWallPickerWrapper = null;
        logoWallPickerWrapper = document.querySelector(".module-logo-wall");

        if (logoWallPickerWrapper !== null) {

            new LogoWallPicker(logoWallPickerWrapper);

        }

        let headerWrapper = null;
        headerWrapper = document.querySelector(".header");

        if (headerWrapper !== null) {

            //new MegaMenu(headerWrapper);
        }

        // PRODUCT GRID *******************************************************************
        let productGridWrapper = null;
        productGridWrapper = document.querySelector(".module-products-grid");

        if (productGridWrapper !== null) {

            new ModuleProductsGrid(productGridWrapper);
        }

        // PROJECT TEASER *************************************************************************************
        let projectTeaserElements = [];
        projectTeaserElements = document.querySelectorAll(".module-projects-teaser, .module-projects-grid");

        for (let c44 = 0; c44 < projectTeaserElements.length; c44++) {

            import('./modules/ProjectsTeaser.js').then(({ ProjectsTeaser }) => {

                new ProjectsTeaser(projectTeaserElements[c44]);

            }).catch((err) => { console.warn(err); });
        }

        // MODALS *************************************************************************************
        let modalElements = [];
        modalElements = document.querySelectorAll(".modal");

        for (let c2 = 0; c2 < modalElements.length; c2++) {

            import('./classes/Modal.js').then(({ Modal }) => {

                new Modal(modalElements[c2]);

            }).catch((err) => { console.warn(err); });
        }

        // PARALLAX MODULE **************************************************************************************
        let parallaxModuleWrappers = document.querySelectorAll(".module-parallax-text-image, .module-parallax-static");

        //console.log(parallaxModuleWrappers);

        for (let pm12 = 0; pm12 < parallaxModuleWrappers.length; pm12++) {

            import('./modules/ParallaxModule.js').then(({ ParallaxModule }) => {

                new ParallaxModule(parallaxModuleWrappers[pm12], this._polylux);

            }).catch((err) => { console.warn(err); });


        }

        // FORMS **************************************************************************************
        let forms = document.querySelectorAll("form.form-validate");

        ////console.log(forms);

        for (let c3 = 0; c3 < forms.length; c3++) {

            import('./libs/VANILLA/Forms/js/Validator.js').then(({ Validator }) => {

                let tempValidator = new Validator(forms[c3], true);
                tempValidator.onsubmit = (ev) => { this.submitHandler(ev); };

                this.validators.push(tempValidator);

            }).catch((err) => { console.warn(err); });


        }

        // CONTACT FORM **************************************************************************************
        let contactModuleWrappers = document.querySelectorAll(".module-form-contact");

        //console.log(contactModuleWrappers);

        for (let cf3 = 0; cf3 < contactModuleWrappers.length; cf3++) {

            import('./forms/ContactForm.js').then(({ ContactForm }) => {

                new ContactForm(contactModuleWrappers[cf3]);

            }).catch((err) => { console.warn(err); });


        }

        // NL FORM ********************************************************************************************
        let nlModuleElement = null;
        nlModuleElement = document.querySelector(".module-newsletter");
        if (nlModuleElement != null) {

            import('./classes/MDCTNewsletter.js').then(({ MDCTNewsletter }) => {

                new MDCTNewsletter(nlModuleElement);

            }).catch((err) => { console.warn(err); });


        }

        // TOOLTIPS *******************************************************************************************
        let tooltipElements = [];
        tooltipElements = document.querySelectorAll(".ww-tooltip");

        for (let c4 = 0; c4 < tooltipElements.length; c4++) {

            import('./classes/WWTooltip.js').then(({ WWTooltip }) => {

                new WWTooltip(tooltipElements[c4]);

            }).catch((err) => { console.warn(err); });


        }

        // Swiper ********************************************************************************************
        let contentSwiperElements = [];
        contentSwiperElements = document.querySelectorAll(".module-content-swiper, .module-hero-swiper, .module-news-swiper, .module-products-swiper, .module-text-swiper, .module-teaser-swiper, .module-projects-swiper, .module-wide-swiper, .module-productfeature-2cols__col.slider");

        for (let c5 = 0; c5 < contentSwiperElements.length; c5++) {

            import('./modules/SlideXSwiper.js').then(({ SlideXSwiper }) => {

                let tempSlider = new SlideXSwiper(contentSwiperElements[c5]);
                this.swipers.push(tempSlider);

            }).catch((err) => { console.warn(err); });


        }

        // MDCT PLAYER WRAPPER *******************************************************************************
        let mdctVideoElements = [];
        mdctVideoElements = document.querySelectorAll(".ww-mdct-player:not(.swiper-video)");

        for (let c6 = 0; c6 < mdctVideoElements.length; c6++) {

            import('./modules/MDCTPlayerWrapper.js').then(({ MDCTPlayerWrapper }) => {

                let tempPlayer = new MDCTPlayerWrapper(mdctVideoElements[c6]);

            }).catch((err) => { console.warn(err); });

        }

        // Accordion *****************************************************************************************
        let accordionElements = [];
        accordionElements = document.querySelectorAll(".module-accordion");

        for (let c7 = 0; c7 < accordionElements.length; c7++) {

            import('./modules/Accordion.js').then(({ Accordion }) => {

                new Accordion(accordionElements[c7]);

            }).catch((err) => { console.warn(err); });

        }

        // EmptyParagraphs ***********************************************************************************
        let paragraphElements = [];
        paragraphElements = document.querySelectorAll(".main-content p");

        for (let p13 = 0; p13 < paragraphElements.length; p13++) {

            import('./helpers/EmptyParagraphs.js').then(({ EmptyParagraphs }) => {

                new EmptyParagraphs(paragraphElements[p13]);

            }).catch((err) => { console.warn(err); });

        }

        // TabsDropDownSwiper ********************************************************************************
        let tabsDropdownSwiperElements = [];
        tabsDropdownSwiperElements = document.querySelectorAll(".module-tabs-dropdown-swiper");

        for (let c8 = 0; c8 < tabsDropdownSwiperElements.length; c8++) {

            import('./modules/TabsDropDownSwiper.js').then(({ TabsDropDownSwiper }) => {

                new TabsDropDownSwiper(tabsDropdownSwiperElements[c8]);

            }).catch((err) => { console.warn(err); });

        }

        // TabsDropDownText **********************************************************************************
        let tabsDropdownTextElements = [];
        tabsDropdownTextElements = document.querySelectorAll(".module-tabs-dropdown-text");

        for (let c753 = 0; c753 < tabsDropdownTextElements.length; c753++) {

            import('./modules/TabsDropDownText.js').then(({ TabsDropDownText }) => {

                new TabsDropDownText(tabsDropdownTextElements[c753]);

            }).catch((err) => { console.warn(err); });

        }

        // TabsDropDown Audiences **********************************************************************************
        let tabsDropdownAudiencesElements = [];
        tabsDropdownAudiencesElements = document.querySelectorAll(".module-tabs-dropdown-audiences");

        for (let c744 = 0; c744 < tabsDropdownAudiencesElements.length; c744++) {

            import('./modules/TabsDropDownAudiences.js').then(({ TabsDropDownAudiences }) => {

                new TabsDropDownAudiences(tabsDropdownAudiencesElements[c744]);

            }).catch((err) => { console.warn(err); });

        }

        // Fellow Filter **************************************************************************************
        let fellowFilterElements = [];
        fellowFilterElements = document.querySelectorAll(".module-profile-grid");

        if (fellowFilterElements.length > 0) {

            import('./classes/FellowFilter.js').then(({ FellowFilter }) => {

                for (let ef1 = 0; ef1 < fellowFilterElements.length; ef1++) {

                    let tempFilter = new FellowFilter(fellowFilterElements[ef1]);
                    //console.log(tempFilter);
                }

            }).catch((err) => {
                console.warn(err);
            });
        }

        // Programmes Filter **********************************************************************************
        let programmeFilterElements = [];
        programmeFilterElements = document.querySelectorAll(".module-programms");

        if (programmeFilterElements.length > 0) {

            import('./classes/ProgrammeFilter.js').then(({ ProgrammeFilter }) => {

                for (let pf1 = 0; pf1 < programmeFilterElements.length; pf1++) {

                    let tempoFilter = new ProgrammeFilter(programmeFilterElements[pf1]);
                    //console.log(tempoFilter);
                }

            }).catch((err) => {
                console.warn(err);
            });
        }

        // Mobile Menu ****************************************************************************************
        let headerElement = document.querySelector(".header");
        if (headerElement != null) {

            new MobileMenu(headerElement);
        }

        // Cookie Settings Button ***************************************************************************************
        let cookieButtonElements = [];
        cookieButtonElements = document.querySelectorAll(".js-cookie-settings");

        for (let cb12 = 0; cb12 < cookieButtonElements.length; cb12++) {

            cookieButtonElements[cb12].addEventListener('click', function (e) {
                e.preventDefault();
                if (typeof BorlabsCookie !== 'undefined' && typeof BorlabsCookie.openCookiePreference === 'function') {
                    BorlabsCookie.openCookiePreference();
                }
            });

        }

        // JS OPT OUT Button ***************************************************************************************
        let jsOptOutButtonElements = [];
        jsOptOutButtonElements = document.querySelectorAll(".js-optout-tracking");

        for (let joo12 = 0; joo12 < jsOptOutButtonElements.length; joo12++) {

            jsOptOutButtonElements[joo12].addEventListener('click', function (e) {
                e.preventDefault();
                wiredminds.optOut();
                alert('Ihre Besuche werden nun nicht mehr erfasst.');
            });

        }


        // Infinite Scroll ************************************************************************************
        let infiniteScrollElements = [];
        infiniteScrollElements = document.querySelectorAll(".module-news-grid");

        for (let isc12 = 0; isc12 < infiniteScrollElements.length; isc12++) {

            import('./classes/InfiniteScroll.js').then(({ InfiniteScroll }) => {
                //new InfiniteScroll(infiniteScrollElements[isc12], this._polylux);
            }).catch((err) => { console.warn(err); });
        }

        // Scroll Visualizer ***********************************************************************************
        new ScrollVisualizer(this._polylux);

        // Header Roll Out *************************************************************************************
        new HeaderRollOut(headerElement);

        // HEADER FOOTER TRACKING ******************************************************************************
        new HeaderTracking();
        new FooterTracking();

        // EFFECTS *********************************************************************************************
        this._effect1Elements = window.document.querySelectorAll(".effect-fadein");
        ////console.log(this._effect1Elements.length);
        for (let e10 = 0; e10 < this._effect1Elements.length; e10++) {

            import('./effects/FadeIn.js').then(({ FadeIn }) => {
                new FadeIn(this._effect1Elements[e10], this._polylux);
            }).catch((err) => { console.warn(err); });
        }

        this._effectMediaElements = window.document.querySelectorAll(".effect-media");
        for (let e20 = 0; e20 < this._effectMediaElements.length; e20++) {

            import('./effects/EffectMedia.js').then(({ EffectMedia }) => {
                new EffectMedia(this._effectMediaElements[e20], this._polylux);
            }).catch((err) => { console.warn(err); });
        }

        this._effect1OnceElements = window.document.querySelectorAll(".effect-fadeOnce");
        for (let e30 = 0; e30 < this._effect1OnceElements.length; e30++) {

            import('./effects/EffectTextOnce.js').then(({ EffectTextOnce }) => {
                new EffectTextOnce(this._effect1OnceElements[e30], this._polylux);
            }).catch((err) => { console.warn(err); });
        }

        this._countUpElements = window.document.querySelectorAll(".module-facts__wrapper__fact.countup");

        for (let e40 = 0; e40 < this._countUpElements.length; e40++) {

            import('./effects/NumCounter.js').then(({ NumCounter }) => {
                new NumCounter(this._countUpElements[e40], this._polylux);
            }).catch((err) => { console.warn(err); });
        }

        let bgImageEffectElements = [];
        bgImageEffectElements = document.querySelectorAll('.module-parallax-static .parallax-box .object-bg, .module-parallax-text-image .parallax-box');
        for (let k = 0; k < bgImageEffectElements.length; k++) {

            import('./effects/ParallaxImageEffect.js').then(({ ParallaxImageEffect }) => {

                new ParallaxImageEffect(bgImageEffectElements[k]);
            }).catch((err) => {
                console.warn(err);
            });
        }

    }

    static submitHandler(ev) {

        //console.log("*****************************");
        //console.log("submitHandler");
        //console.log(ev);
        //console.log(ev.validator.expose());

    }

    static brand() {

        console.info("@@@@@@   @@@@@@@  @@@@@@@@@@@      @@@@@@@@@  @@@@@@@@@@@@@");
        console.info("@@@@@@   @@@@@@@  @@@@@@@@@@@@   @@@@@@@@@@@@ @@@@@@@@@@@@@");
        console.info("@@@@@@@  @@@@@@@  @@@@@ @@@@@@@  @@@@@  @@@@@@@@@@@@@@@@@@@");
        console.info("@@@@@@@  @@@@@@@  @@@@@   @@@@@  @@@@@   @@@@@    @@@@@    ");
        console.info("@@@@@@@ @@@@@@@@  @@@@@   @@@@@  @@@@@   @@@@@    @@@@@    ");
        console.info("@@@@@@@@@@@@@@@@  @@@@@   @@@@@  @@@@@            @@@@@    ");
        console.info("@@@@@@@@@@@ @@@@  @@@@@   @@@@@  @@@@@            @@@@@    ");
        console.info("@@@@@@@@@@@ @@@@  @@@@@   @@@@@  @@@@@   @@@@@    @@@@@    ");
        console.info("@@@@ @@@@@@ @@@@  @@@@@   @@@@@  @@@@@   @@@@@    @@@@@    ");
        console.info("@@@@ @@@@@  @@@@  @@@@@  @@@@@@  @@@@@  @@@@@@    @@@@@    ");
        console.info("@@@@ @@@@@  @@@@  @@@@@@@@@@@@   @@@@@@@@@@@@     @@@@@    ");
        console.info("@@@@  @@@@  @@@@  @@@@@@@@@@      @@@@@@@@@@      @@@@@    ");
    }
}

de.ww.MainApp.brand();
de.ww.MainApp.main();